import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Subject, takeUntil } from 'rxjs';
import { EventService } from '@providers/event/event.service';

/**
 * Status Bar Component.
 *
 * @exports
 * @class StatusBarComponent
 */
@Component({
  selector: 'app-status-bar',
  template: '',
  standalone: true
})
export class StatusBarComponent implements OnInit, OnDestroy {
  private readonly events = inject(EventService);

  destroyed: Subject<boolean>;

  /**
   * Creates an instance of StatusBarComponent.
   */
  constructor() {
    this.destroyed = new Subject();
  }

  /**
   * @description On init.
   * @memberof StatusBarComponent
   */
  ngOnInit(): void {
    this.listenEvents();
  }

  /**
   * Ng on destroy.
   *
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  /**
   * @description Route listen.
   * @memberof StatusBarComponent
   */
  listenEvents(): void {
    const isNative = Capacitor.isNativePlatform();
    const isNotAndroid = Capacitor.getPlatform() !== 'android';

    this.events
      .listen('STATUS_BAR_CHANGE')
      .pipe(takeUntil(this.destroyed))
      .subscribe({
        /**
         * On user emit a value to alter status bar.
         *
         * @param {object} value Value.
         */
        next: (value): void => {
          if (isNative) {
            if (isNotAndroid) {
              /**
               * Set to default color if user passes null value.
               */
              if (value.backgroundColor === null) {
                StatusBar.setBackgroundColor({ color: '#ffffff' });
              } else if (typeof value.backgroundColor === 'string') {
                StatusBar.setBackgroundColor({ color: value.backgroundColor });
              }
            }
            /**
             * Set to default style if user passess null value.
             */
            if (value.style === null) {
              StatusBar.setStyle({ style: Style.Light });
            } else if (typeof value.style === 'string') {
              StatusBar.setStyle({ style: value.style });
            }
          }
        }
      });
  }
}
